import React, { Fragment, useState } from 'react'
import {  CalendarMonthRounded, ConfirmationNumberRounded,  Menu, PeopleAltRounded, Star, WatchLaterRounded } from '@mui/icons-material'
import { Link} from 'react-router-dom'
import { toast } from 'react-toastify'
import { ENDPOINT} from '../../constants'
import { useAuth } from '../../contexts/AuthContext'
import Button from '../Button'
import Modal from '../Modal'
import { FetchApi } from '../../api/fetch'

type Props = {
   data: any;
   getCourses: () => void
}

function CourseCard({ data, getCourses }: Props) {
   const [deleteInitiated, setDeleteInitiated] = useState<boolean>()
   const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()

   const handleClose = () => {
      setDeleteInitiated(false)
   }
   const onDelete = () => {
      setDeleteInitiated(true)
   }

   const deleteCourse = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()
      try {
         let response: any = await FetchApi({
            endpoint: `${ENDPOINT.BASE_ENDPOINT_ACADEMY}/${data?.id}/delete-course`,
            method: "DELETE",
            JWT: userJWT
         })
         // response = await response.json()

         if (response) {
            getCourses();
            // toast.success(response.message)
         }
         // if (!response.success) {
         //    toast.error(response.message)
         // }
         setIsLoadingOverlayDisplay(false)
         setDeleteInitiated(false)
      } catch (error: any) {
         setIsLoadingOverlayDisplay(false)
         toast.error(error.message)

      }
   }

   const downloadAttendance = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      try {
         const stats = await FetchApi({
            endpoint: `${ENDPOINT.BASE_ENDPOINT_ACADEMY}/${data?.id}/get-attendance`,
            method: "POST",
            JWT: userJWT,
            format: 'blob'
         })

         // const stats = await res.blob()

         var file = window.URL.createObjectURL(stats);
         window.location.assign(file);
      } catch (error) {
         console.log(error);
      }
      setIsLoadingOverlayDisplay(false)
   }

   return (
      <Fragment>

         <div className="bg-gray-90 flex items-start justify-between p-4 my-4 rounded-lg">
            <div className='flex items-center w-full gap-3'>
               <div>
                  <Menu className="h-8 text-gray-50" />
               </div>
               <div className="flex items-center w-full gap-3">

                  <div className="w-3/12 h-36 rounded-md" >
                     <img className="rounded-md w-full h-36" src={data?.bannerURL} alt='banner' style={{
                        objectFit: 'cover'
                     }} />
                  </div>
                  <div className='w-full'>
                     <div className='flex flex-wrap items-center justify-between gap-3 mb-2'>
                        <div className='flex gap-2 items-center'>
                           <p className='text-md font-normal'>{data.name}</p>
                           {
                              data.isFeatured &&
                              <span className='block flex items-center gap-1 px-2 py-1 border border-yellow-500 rounded-lg text-xs text-yellow-500'>Featured <Star className='text-yellow-500' fontSize='small' /></span>
                           }
                        </div>
                        <div className="flex">
                           <Link to={{ pathname: 'manage/', state: data }}>
                              <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs">
                                 <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 15.166H2C1.72667 15.166 1.5 14.9393 1.5 14.666C1.5 14.3927 1.72667 14.166 2 14.166H14C14.2733 14.166 14.5 14.3927 14.5 14.666C14.5 14.9393 14.2733 15.166 14 15.166Z" fill="#667085" />
                                    <path d="M12.6804 2.82043C11.387 1.5271 10.1204 1.49376 8.79371 2.82043L7.98704 3.6271C7.92037 3.69376 7.89371 3.80043 7.92038 3.89376C8.42704 5.66043 9.84038 7.07376 11.607 7.58043C11.6337 7.5871 11.6604 7.59376 11.687 7.59376C11.7604 7.59376 11.827 7.5671 11.8804 7.51376L12.6804 6.7071C13.3404 6.05376 13.6604 5.42043 13.6604 4.78043C13.667 4.12043 13.347 3.48043 12.6804 2.82043Z" fill="#667085" />
                                    <path d="M10.4056 8.18654C10.2122 8.0932 10.0256 7.99987 9.84558 7.8932C9.69891 7.80654 9.55891 7.7132 9.41891 7.6132C9.30558 7.53987 9.17224 7.4332 9.04558 7.32654C9.03224 7.31987 8.98558 7.27987 8.93224 7.22654C8.71224 7.03987 8.46558 6.79987 8.24558 6.5332C8.22558 6.51987 8.19224 6.4732 8.14558 6.4132C8.07891 6.3332 7.96558 6.19987 7.86558 6.04654C7.78558 5.94654 7.69224 5.79987 7.60558 5.6532C7.49891 5.4732 7.40558 5.2932 7.31224 5.10654C7.18987 4.84431 6.8457 4.76641 6.64108 4.97103L2.89224 8.71987C2.80558 8.80654 2.72558 8.9732 2.70558 9.08654L2.34558 11.6399C2.27891 12.0932 2.40558 12.5199 2.68558 12.8065C2.92558 13.0399 3.25891 13.1665 3.61891 13.1665C3.69891 13.1665 3.77891 13.1599 3.85891 13.1465L6.41891 12.7865C6.53891 12.7665 6.70558 12.6865 6.78558 12.5999L10.5406 8.84484C10.7411 8.64432 10.6658 8.29929 10.4056 8.18654Z" fill="#667085" />
                                 </svg>
                                 Edit
                              </button>
                           </Link>
                           <button onClick={downloadAttendance} className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs">
                              <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path d="M12.9865 6.5H9.85605V10.6667C9.85605 10.94 9.59325 11.1667 9.27634 11.1667C8.95943 11.1667 8.69663 10.94 8.69663 10.6667V6.5H5.5662C3.09277 6.5 1.54688 7.83333 1.54688 9.96667V11.6933C1.54688 13.8333 3.09277 15.1667 5.5662 15.1667H12.9788C15.4522 15.1667 16.9981 13.8333 16.9981 11.7V9.96667C17.0058 7.83333 15.4599 6.5 12.9865 6.5Z" fill="#667085" />
                                 <path d="M9.85623 3.54094L11.4562 4.92094C11.5722 5.02094 11.719 5.0676 11.8659 5.0676C12.0128 5.0676 12.1596 5.02094 12.2756 4.92094C12.4997 4.7276 12.4997 4.4076 12.2756 4.21427L9.68619 1.98094C9.46203 1.7876 9.09102 1.7876 8.86686 1.98094L6.27749 4.21427C6.05334 4.4076 6.05334 4.7276 6.27749 4.92094C6.50165 5.11427 6.87266 5.11427 7.09681 4.92094L8.69681 3.54094V6.50094H9.85623V3.54094Z" fill="#667085" />
                              </svg>

                              Attendance
                           </button>
                           <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs" onClick={onDelete}>
                              <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path d="M16.2879 3.98732C15.0435 3.88065 13.799 3.80065 12.5468 3.74065V3.73398L12.3768 2.86732C12.2609 2.25398 12.0908 1.33398 10.2821 1.33398H8.25699C6.45602 1.33398 6.28597 2.21398 6.1623 2.86065L5.99998 3.71398C5.28114 3.75398 4.5623 3.79398 3.84346 3.85398L2.26665 3.98732C1.94201 4.01398 1.71013 4.26065 1.74104 4.53398C1.77196 4.80732 2.05022 5.00732 2.37486 4.98065L3.95167 4.84732C8.00191 4.50065 12.0831 4.63398 16.1797 4.98732C16.2029 4.98732 16.2183 4.98732 16.2415 4.98732C16.5352 4.98732 16.7903 4.79398 16.8212 4.53398C16.8444 4.26065 16.6125 4.01398 16.2879 3.98732Z" fill="#667085" />
                                 <path d="M14.863 5.92602C14.6775 5.75935 14.4225 5.66602 14.1597 5.66602H4.38962C4.12681 5.66602 3.86401 5.75935 3.68623 5.92602C3.50846 6.09268 3.40797 6.31935 3.42343 6.55268L3.90266 13.3927C3.98768 14.406 4.0959 15.6727 6.79348 15.6727H11.7558C14.4534 15.6727 14.5616 14.4127 14.6466 13.3927L15.1258 6.55935C15.1413 6.31935 15.0408 6.09268 14.863 5.92602ZM10.5577 12.3327H7.98382C7.66691 12.3327 7.40411 12.106 7.40411 11.8327C7.40411 11.5593 7.66691 11.3327 7.98382 11.3327H10.5577C10.8746 11.3327 11.1374 11.5593 11.1374 11.8327C11.1374 12.106 10.8746 12.3327 10.5577 12.3327ZM11.207 9.66602H7.34227C7.02536 9.66602 6.76256 9.43935 6.76256 9.16602C6.76256 8.89268 7.02536 8.66602 7.34227 8.66602H11.207C11.5239 8.66602 11.7867 8.89268 11.7867 9.16602C11.7867 9.43935 11.5239 9.66602 11.207 9.66602Z" fill="#667085" />
                              </svg>
                              Delete
                           </button>
                        </div>
                     </div>
                     <p className="font-extralight text-sm text-gray-40 mb-2">
                        {data.description}
                     </p>
                     <div className='flex items-center gap-3 my-2 text-sm'>
                        <div className='flex items-center gap-2'>
                           <div className="w-6 h-6">
                              <img src={data.logoURL} alt='logo' className="rounded-full w-6 h-6" />
                           </div>
                           <span className='text-md font-light text-blue-500'>{data.projectName}</span>
                        </div>
                        <div className='flex items-center gap-2'>
                           <WatchLaterRounded className='w-5' />
                           <span className='text-md'>{data.timeRequired || 0} min</span>
                        </div>
                        <div className='flex items-center gap-1'>
                           <ConfirmationNumberRounded className='w-5 text-accent-green' />
                           <span className='text-md'>{data.numberOfTicketAward} Tickets</span>
                        </div>
                        <div className='flex items-center gap-2'>
                           <PeopleAltRounded className='w-5' />
                           <span className='text-md'>{data.noOfAttempted} / {data.noMaxAttendees ? 'Infinite Attendees' : `${data.maxAttendees} Attendees (max)`} </span>
                        </div>
                     </div>
                     <div className='flex items-center gap-2 text-sm'>
                        <CalendarMonthRounded className='w-5' />
                        <p className='text-md font-normal flex gap-4 items-center wrap'> {new Date(data.startDate).toUTCString().replace('GMT', 'UTC')} <span className='text-xl font-medium'>-</span> {data.noExpiry ? 'No Expiry' : new Date(data.endDate).toUTCString().replace('GMT', 'UTC')}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <Modal show={deleteInitiated} hide={handleClose} sub='Are you sure you want to delete course'>
            <div className='flex justify-center gap-3 mt-8'>
               <div className=" text-center">
                  <button onClick={handleClose} className="block bg-gradient rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 text-md text-semibold">
                     <span
                        className="w-36 bg-gray-90 block m-0.5 rounded-lg py-3"
                     >
                        No
                     </span>
                  </button>
               </div>
               <Button
                  type="button"
                  className="mb-0 sm:mb-2 w-36 btn bg-gradient text-kyzzen-primary rounded-lg font-medium "
                  onClick={deleteCourse}
               >
                  Yes
               </Button>
            </div>
         </Modal>

      </Fragment>
   )
}

export default CourseCard